import {
  Box,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useStore } from "@roc/client-portal-shared/hooks";
import { NumberFormat, TextField } from "@roc/ui";
import { observer } from "mobx-react";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    alignContent: 'center',
    textAlign: 'center'
  },
  itemsDivider: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2px'
  },
}));

interface RangeFiltersProps {
  label: string;
  fieldName: string;
  customInput?: React.ElementType;
  InputComponent?: React.ElementType;
}

export const RangeField = observer(
  ({ label, fieldName, customInput = TextField, InputComponent = NumberFormat }: RangeFiltersProps) => {
    const { compToolStoreV2: compToolStore } = useStore();
    const { compToolFiltersStore } = compToolStore;

    const classes = useStyles();

    const onFieldChange = (ev, value, fieldName, range) => {
      const newValue = ev ? ev.target.value : value;
      if (newValue === '.') {
        compToolFiltersStore.onFieldsChange(fieldName, range, '');
      } else {
        compToolFiltersStore.onFieldsChange(fieldName, range, newValue);
      }
    }

    return (
      <Box className={classes.root}>
        <Typography variant='body1' style={{ fontWeight: "bold" }}>
          {label}
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={5}>
            <InputComponent
              testId={`${fieldName}-min`}
              allowNegative={false}
              variant="outlined"
              label="Minimum"
              value={compToolFiltersStore.form.fields[fieldName].min.value}
              placeholder={compToolFiltersStore.form.fields[fieldName]?.suggestedRange?.min}
              fullWidth
              InputLabelProps={{ shrink: true }}
              customInput={customInput}
              onChange={(ev, value) => {
                onFieldChange(ev, value, fieldName, 'min');
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2} className={classes.label}>
            <Divider variant='fullWidth' className={classes.itemsDivider} />
          </Grid>
          <Grid item xs={12} sm={5}>
            <InputComponent
              testId={`${fieldName}-max`}
              allowNegative={false}
              variant="outlined"
              label="Maximum"
              value={compToolFiltersStore.form.fields[fieldName].max.value}
              placeholder={compToolFiltersStore.form.fields[fieldName]?.suggestedRange?.max}
              fullWidth
              InputLabelProps={{ shrink: true }}
              customInput={customInput}
              onChange={(ev, value) => {
                onFieldChange(ev, value, fieldName, 'max');
              }}
            />
          </Grid>
        </Grid>
      </Box>
    );
  }
);
